// import {getCookie} from "../../common/js/util";

const user = {
    state: {
        includePageNames:[],
        firstLevelData:[],
        parentCode:"",
        hotelCode:"",   // 酒店code 
        hotelItems:1,   //  酒店的主题风格
        hotelSet:"",
        moduleParams:"",
        userLogin:"",
        foodData:"",
        paramsData:{}
    },

    mutations: {
        firstLevelData(state,msg){
            state.firstLevelData = msg;
        },
        includePageNames(state,msg){
            state.includePageNames = msg;
        },
        parentCode(state,msg){
            state.parentCode = msg;
        },
        hotelCode(state,msg){
            state.hotelCode = msg;
        },
        hotelItems(state,msg){
            state.hotelItems = msg;
        },
        hotelSet(state,msg){
            state.hotelSet = msg;
        },
        moduleParams(state,msg){
            state.moduleParams = msg;
        },
        userLogin(state,msg){
            state.userLogin = msg;
        },
        foodData(state,msg){
            state.foodData = msg;
        },
        paramsData(state,msg){
            state.paramsData = msg;
        }
    },
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js